import { Clickable } from '@carvana/vdp-components';
import classNames from 'classnames';
import { useContext } from 'react';
import ModalContext from '~/contexts/ModalContext/ModalContext';
import FilterIcon from '~/icons/FilterIcon';
import { IconWithTextWrapper } from '../SearchHeader/SearchHeader.styles';
import useGetFilterTags from '../useGetFilterTags';

export default function MobileFilters({ isStickySearchBar }) {
  const filterTags = useGetFilterTags();
  const { setFilterModalOpen } = useContext(ModalContext);

  const numberOfTags = filterTags.length;

  return (
    <>
      <Clickable
        className={classNames(
          'flex h-full items-center pl-16 self-center l:hidden',
          {
            'text-white l:hidden': isStickySearchBar
          }
        )}
        data-analytics-id="Filter Button - toggle"
        onClick={() => setFilterModalOpen(true)}
      >
        <IconWithTextWrapper className="h-full t-header-xs m:t-header-s">
          <FilterIcon stroke={isStickySearchBar ? 'white' : undefined} />
          <span className="m-0">Filter</span>
        </IconWithTextWrapper>
        {numberOfTags > 0 && (
          <div
            className={classNames(
              'flex h-[16px] items-center justify-center ml-4 rounded-full t-label-xs w-[16px]',
              {
                'bg-white text-blue-6': isStickySearchBar,
                'bg-blue-4 text-white': !isStickySearchBar
              }
            )}
          >
            {numberOfTags}
          </div>
        )}
      </Clickable>
    </>
  );
}
